export const swiperOptions = {
    slidesPerView: 1.07,
    spaceBetween: 24,

    breakpoints: {
        319: {
            slidesPerView: 1,
        },
        464: {
            slidesPerView: 1,
        },
        744: {
            slidesPerView: 1,
        },
        984: {
            slidesPerView: 2,
        },
        1200: {
            slidesPerView: 2.8,
        },
        1440: {
            slidesPerView: 3,
        },
        1700: {
            slidesPerView: 3,
        },
    },
};
